import React, { useEffect, useState } from "react";
import {
  BackButton,
  CancelButton,
  ExportButton,
  ImportButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import {
  NuDate,
  NuInput,
  NuInputWithError,
  NuMobileNumber,
  NuTextArea,
  NuUpload,
} from "../../../../Components/Utils/Input";
import FormikSelectTwo, {
  FormikSelectWithAdd,
  SelectProductWithError,
} from "../../../../Components/Utils/Select";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import * as yup from "yup";
import DropDownAddMetaData, {
  DropDownAddUnitWithError,
} from "../../../../Components/Utils/selectAddMetaData";
import axiosInstance from "../../../../Services/axiosCommon";
import UseCustomerDropDownNew from "../../../../Components/Hooks/useCustomerSearch";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import { useToast } from "../../../../Components/Others/ToastServices";
import Attachement from "../../../../Components/Utils/CustomAttrachmentupload";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import DeleteIcon from "../../../../Components/Icons/Delete";
import UseEqupiProductDropDownNew from "../../../../Components/Hooks/useEqupiProductDropDown";
import EditIcon from "../../../../Components/Icons/Edit";
import Select from "react-select";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { format, addMonths } from "date-fns";
import UseDropDownNew from "../../../../Components/Hooks/useDropDownNew";
import MultiSelect from "../../../../Components/Utils/MultiSelect";
import useFetchMetaStar from "../../../../Components/Hooks/useFetchMetaStar";
import { SettingHeading } from "../../../../Components/Utils/Settingheading";
import NuDateFormate from "../../../../Components/Utils/NuDate";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";

function CreateContracts() {
  const now = new Date();
  const toast = useToast();
  const navigate = useNavigate();
  const [minRenewalDate, setMinRenewalDate] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupEquipment, setShowPopupEquipment] = useState(false);
  const [isInspectionEditable, setIsInspectionEditable] = useState(false);
  const [isEquipmentEditable, setIsEquipmentEditable] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const { Oncancel, addFormData, isLoading } = useAddFormData();
  const [Equipitems, setEquipItems] = useState([]);
  const [rows, setRows] = useState([]);
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");
  const [searchClient, setSearchClient] = useState("");
  const [searchequipment, setSearchequipment] = useState("");
  const [inspectionProductError, setInspectionProductError] = useState("");
  const [inspectionUnitError, setInspectionUnitError] = useState("");
  const [inspectionQuantityError, setInspectionQuantityError] = useState("");
  const [inspectionError, setInspectionError] = useState("");
  const [equipmentProductError, setEquipmentProductError] = useState("");
  const [equipmentUnitError, setEquipmentUnitError] = useState("");
  const [equipmentQuantityError, setEquipmentQuantityError] = useState("");
  const [equipmentError, setEquipmentError] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [Newcontract, setContract] = useState([]);
  const [sortedProList, setSortedProList] = useState([]);
  const [oldData, setOldData] = useState([]);
  const [image, setImage] = useState([]);
  const [createNew, setCreateNew] = useState({
    amount: "",
    attachments: [],
    clientId: "",
    description: "",
    duration: "",
    endDate: "",
    formSelection: [],
    inspectionType: "",
    renewalDate: "",
    srId: null,
    startDate: "",
    status: "",
    equipments: [],
    schedules: [],
     buildingName:'',
    notes:"",
    paymentTerms:"",
noticePeriod:''
  });

  const { data: client, setDataCustomer } = UseCustomerDropDownNew(
    "/clients/drop-down",
    searchClient
  );

  const { data: Item, setData } = UseEqupiProductDropDownNew(
    "/equipments/drop-down",
    searchequipment
  );

  const { value: unit, getData: refunit } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "unit_equipments"
  );

  const { value: location, getData: reflocation } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Inspection_Location"
  );

  const { value: industry, getData: refindustry } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "industry"
  );

  const { value: Rating, getData: refRating } = useFetchMetaStar(
    `/dropdown/dropdown-details/`,
    "ratings"
  );

  const { value: designation, getData: refdesignation } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Designation_Client"
  );

  const { data: form } = UseDropDownNew(`/form/drop-down`);

      const {value:paymentTerms ,getData:refpaymentTerms} = useFetchMataData(`/dropdown/dropdown-details/`,'paymentTerms')


    function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {  
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);


    setImage(fileArr);
    e.target.value = null;
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };

  const validationSchema = yup.object({
    duration: yup.string().required("Duration is required!"),
    clientId: yup.string().required("Client is required!"),
    startDate: yup.date().required("Start date is required"),
    endDate: yup
      .date()
      .required("End date is required")
      .min(yup.ref("startDate"), "End date must be after start date"),
    inspectionDates: yup.array().of(
      yup.object().shape({
        date: yup
          .date()
          .required("Date is required")
          .test(
            "within-range",
            "Date must be between contract start and end",
            function (value) {
              const { startDate, endDate } = this.options.context;
              if (!value || !startDate || !endDate) return false;
              const dateVal = new Date(value);
              return (
                dateVal >= new Date(startDate) && dateVal <= new Date(endDate)
              );
            }
          ),
      })
    ),
  });

  const formik = useFormik({
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema,
    context: {
      startDate: createNew.startDate,
      endDate: createNew.endDate,
    },
    onSubmit: async (value, { resetForm }) => {
      let formData = new FormData();
      const valueWithItems = {
        ...value,
        equipments: Equipitems,
        schedules: rows,
        inspectionDetails: items,
      };
      formData.append("json_data", JSON.stringify(valueWithItems));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
      await addFormData({
        url: `/contract/new-contract`,
        formData: formData,
        navigateUrl: `/Contract-management/contracts`,
        resetForm: resetForm,
      });
    },
  });

  const [addInspection, setAddInspection] = useState({
    equipmentId: "",
    // unit: "",
    // quantity: "",
    location: "",
    inspectionType: "",
    formSelection: "",
  });

  const [addEquipment, setAddEquipment] = useState({
    equipmentId: "",
    unit: "",
    quantity: "",
  });

  const formikAddInspection = useFormik({
    initialValues: addInspection,
    validateOnChange: false,
    validateOnBlur: false,
  });

  const formikAddEquipment = useFormik({
    initialValues: addEquipment,
    validateOnChange: false,
    validateOnBlur: false,
  });

    const ExportFormik = useFormik({
      enableReinitialize: true,
      initialValues: '',
      validateOnChange: false,
      validateOnBlur: false,
      onSubmit: async (value, { resetForm }) => {
        if (Equipitems) {
          let finalData = [];
          Equipitems.forEach((item, index) => {
            console.log("Item", item);
            let tempData = {
              EquipmentId: item?.equipmentId || "",
              Name: item?.productName || "",
              Unit: item?.unit || "",
              Quantity: item?.quantity || "",
            };
            finalData.push(tempData);
          });
          const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
          const fileExtension = ".xlsx";
          const wb = XLSX.utils.book_new();
  
          const ws = XLSX.utils.aoa_to_sheet([
            Object.keys(finalData[0]),
            ...finalData.map((obj) => Object.values(obj)),
          ]);
  
          const headers = Object.keys(finalData[0]);
          headers.forEach((header, index) => {
            const headerCellRef = XLSX.utils.encode_cell({ r: 4, c: index });
            if (!ws[headerCellRef]) return;
            ws[headerCellRef].s = { font: { bold: true } };
          });
  
          ws["!cols"] = [
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
          ];
          XLSX.utils.book_append_sheet(wb, ws, "Data");
          const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
          const data = new Blob([excelBuffer], { type: fileType });
          FileSaver.saveAs(
            data,
            `Equiment Export ${new Date().toISOString()} ` + fileExtension
          );
        }
      },
    });
  


  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const closeModal = () => {
    setShowImportModal(false);
  };

    const closeFilterDialogebox = () => {
    setShowExport(false);
  };

  const readExcel = (file) => {
    if (!file) {
      setError("Please select a file to import.");
      return;
    }

    const promise = new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e) => {
        const bufferArray = e.target.result;
        const wb = XLSX.read(bufferArray, { type: "buffer" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws);
        console.log("DATA -- IMPORT", data);

        const mappedData = data.map((item) => ({
          equipmentId: item.EquipmentId || "",
          productName: item.Name || "",
          quantity: item.Quantity || 0,
          unit: item.Unit || "",
        }));

        resolve(mappedData);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });

    promise
      .then((mappedData) => {
        setEquipItems([...Equipitems, ...mappedData]);
        setShowImportModal(false);
        setError("");
      })
      .catch((err) => {
        setError(
          "Failed to read the file. Please ensure it's a valid Excel file."
        );
        console.error(err);
      });
  };

  const [showExport, setShowExport] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const togglePopupEqupiment = () => {
    setShowPopupEquipment(!showPopupEquipment);
  };

  function getView(clientId) {
    axiosInstance
      .get(`/survey-report/drop-down/client/${clientId}`)
      .then((res) => {
        const formattedContracts =
          res.data?.map((item) => ({
            value: item.id,
            label: item.name,
          })) || [];
        setContract(formattedContracts);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  const getDaysFromDuration = (duration) => {
    const value = parseInt(duration.split(" ")[0]);
    return value * 30;
  };

  const calculateEndDateFromDays = (startDate, duration) => {
    const daysToAdd = getDaysFromDuration(duration);
    const date = new Date(startDate);
    date.setDate(date.getDate() + daysToAdd - 1);
    return date.toISOString().split("T")[0];
  };

  const handleAddInspection = () => {
    let hasError = false;
    if (!formikAddInspection.values.equipmentId) {
      setInspectionProductError("Product is required");
      hasError = true;
    } else {
      setInspectionProductError("");
    }
    // if (!formikAddInspection.values.unit) {
    //   setInspectionUnitError("Unit is required");
    //   hasError = true;
    // } else {
    //   setInspectionUnitError("");
    // }
    // if (!formikAddInspection.values.quantity) {
    //   setInspectionQuantityError("Quantity is required");
    //   hasError = true;
    // } else {
    //   setInspectionQuantityError("");
    // }
    if (hasError) return;

    if (
      formikAddInspection.values.equipmentId
      // formikAddInspection.values.quantity
    ) {
      const newItem = {
        equipmentId: formikAddInspection.values.equipmentId,
        productName:
          sortedProList.find(
            (i) => i.value === formikAddInspection.values.equipmentId
          )?.label || formikAddInspection.values.equipmentId,
        // quantity: formikAddInspection.values.quantity,
        // unit: formikAddInspection.values.unit,
        location: formikAddInspection.values.location || "",
        inspectionType: formikAddInspection.values.inspectionType || "",
        formSelection: formikAddInspection.values.formSelection || [],
      };
      setItems([...items, newItem]);
      let updatedItems = Item.filter(
        (it) => it.value !== formikAddInspection.values.equipmentId
      );
      setData(updatedItems);
      formikAddInspection.resetForm();
      setAddInspection({
        equipmentId: "",
        unit: "",
        // quantity: "",
        // location: "",
        inspectionType: "",
        formSelection: [],
      });
      setInspectionError("");
    }
  };

  const handleAddEquipment = () => {
    let hasError = false;
    if (!formikAddEquipment.values.equipmentId) {
      setEquipmentProductError("Product is required");
      hasError = true;
    } else {
      setEquipmentProductError("");
    }
    if (!formikAddEquipment.values.unit) {
      setEquipmentUnitError("Unit is required");
      hasError = true;
    } else {
      setEquipmentUnitError("");
    }
    if (!formikAddEquipment.values.quantity) {
      setEquipmentQuantityError("Quantity is required");
      hasError = true;
    } else {
      setEquipmentQuantityError("");
    }
    if (hasError) return;

    if (
      formikAddEquipment.values.equipmentId &&
      formikAddEquipment.values.quantity
    ) {
      const newItem = {
        equipmentId: formikAddEquipment.values.equipmentId,
        productName:
          sortedProList.find(
            (i) => i.value === formikAddEquipment.values.equipmentId
          )?.label || formikAddEquipment.values.equipmentId,
        quantity: formikAddEquipment.values.quantity,
        unit: formikAddEquipment.values.unit,
      };
      setEquipItems([...Equipitems, newItem]);
      let updatedItems = Item.filter(
        (it) => it.value !== formikAddEquipment.values.equipmentId
      );
      setData(updatedItems);
      formikAddEquipment.resetForm();
      setAddEquipment({
        equipmentId: "",
        unit: "",
        quantity: "",
      });
      setEquipmentError("");
    }
  };

  const handleQuantityChange = (e, index, section) => {
    const updatedQuantity = e.target.value;
    if (section === "inspection") {
      const updatedItems = items.map((item, idx) => {
        if (idx === index) {
          return { ...item, quantity: updatedQuantity };
        }
        return item;
      });
      setItems(updatedItems);
    } else {
      const updatedItems = Equipitems.map((item, idx) => {
        if (idx === index) {
          return { ...item, quantity: updatedQuantity };
        }
        return item;
      });
      setEquipItems(updatedItems);
    }
  };

  const handleProductUnitChange = (value, index, section) => {
    if (section === "inspection") {
      const updatedItems = items.map((item, idx) => {
        if (idx === index) {
          return { ...item, unit: value?.value };
        }
        return item;
      });
      setItems(updatedItems);
    } else {
      const updatedItems = Equipitems.map((item, idx) => {
        if (idx === index) {
          return { ...item, unit: value?.value };
        }
        return item;
      });
      setEquipItems(updatedItems);
    }
  };

  const handleDeleteItem = (indexToDelete, section) => {
    if (section === "inspection") {
      const deletedItem = items[indexToDelete];
      const updatedItems = items.filter((_, index) => index !== indexToDelete);
      setItems(updatedItems);
      if (deletedItem) {
        setData([
          ...Item,
          { value: deletedItem.equipmentId, label: deletedItem.productName },
        ]);
      }
    } else {
      const deletedItem = Equipitems[indexToDelete];
      const updatedItems = Equipitems.filter(
        (_, index) => index !== indexToDelete
      );
      setEquipItems(updatedItems);
      if (deletedItem) {
        setData([
          ...Item,
          { value: deletedItem.equipmentId, label: deletedItem.productName },
        ]);
      }
    }
  };

  const resetForm = () => {
    formik.setValues({
      ...formik.values,
      companyName: "",
      email: "",
      industry: "",
      pcName: "",
      pcDesignation: "",
      pcCountryCode: "",
      pcMobile: "",
      phoneCC: "",
      phone: "",
      ratings: "",
    });
    setShowPopup(false);
  };

  const handlePopupSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append(
      "json_data",
      JSON.stringify({
        companyName: formik.values.companyName || "",
        email: formik.values.email || "",
        industry: formik.values.industry || "",
        category: formik.values.category || "",
        pcName: formik.values.pcName || "",
        pcDesignation: formik.values.pcDesignation || "",
        pcCountryCode: formik.values.pcCountryCode || "",
        pcMobile: formik.values.pcMobile || "",
        phone: formik.values.phone || "",
        phoneCC: formik.values.phoneCC || "",
        ratings: formik.values.ratings || "",
      })
    );
    try {
      const response = await axiosInstance.post(
        "/clients/new-client",
        formData
      );
      const createdAgent = response.data?.data;
      setDataCustomer((prevCustomers) => [
        {
          label: formik.values.companyName || "-",
          value: createdAgent,
        },
        ...prevCustomers,
      ]);
      resetForm();
    } catch (error) {
      console.error("Error creating new customer:", error);
    }
  };

    const handlePopupSubmitEquipmt = async (e) => {
      e.preventDefault();
  
      const formData = new FormData();
      formData.append(
        "json_data",
        JSON.stringify({
          name: formik.values.name || "",
          brand: formik.values.brand || "",
          unit: formik.values.unit || "",
          model: formik.values.model || "",
        })
      );
      try {
        const response = await axiosInstance.post(
          "/equipments/new-equipment",
          formData
        );
        const createdEquipt = response.data?.data;
  
        setData((prevEquipments) => [
          {
            label: formik.values.name || "-",
            value: createdEquipt,
          },
          ...prevEquipments,
        ]);
  
        // Clear and close popup
        formik.setFieldValue("name", "");
        formik.setFieldValue("brand", "");
        formik.setFieldValue("unit", "");
        formik.setFieldValue("model", "");
        togglePopupEqupiment();
      } catch (error) {
        console.error("Error creating new equipment:", error);
      }
    };

  useEffect(() => {
    if (formik.values.clientId) {
      getView(formik.values.clientId);
    } else {
      setContract([]);
    }
  }, [formik.values.clientId]);

  useEffect(() => {
    const { duration, startDate } = formik.values;
    if (duration && startDate) {
      const calculatedEndDate = calculateEndDateFromDays(startDate, duration);
      formik.setFieldValue("endDate", calculatedEndDate);
      formik.setFieldValue("renewalDate", calculatedEndDate);
      setMinRenewalDate(calculatedEndDate);
    }
  }, [formik.values.duration, formik.values.startDate]);

  useEffect(() => {
    const { endDate } = formik.values;
    if (endDate) {
      formik.setFieldValue("renewalDate", endDate);
    }
  }, [formik.values.endDate]);

  useEffect(() => {
    if (Item) {
      const union = Array.from(
        new Map(
          [...Item, ...oldData].map((item) => [item?.value, item])
        ).values()
      );
      let data = union.sort((a, b) => a.label.localeCompare(b.label));
      setSortedProList(data);
    }
  }, [Item]);

  useEffect(() => {
    if (formikAddInspection.values.equipmentId) {
      const findValue = sortedProList.filter(
        (v) => formikAddInspection.values?.equipmentId == v.value
      );
      setOldData(findValue);
    }
  }, [formikAddInspection.values.equipmentId]);

  return (
    <div className="w-full h-full py-2 px-4">
      <div className="flex justify-between w-full">
        <Breadcrumb
          items={[
            {
              name: "Contracts",
              link: "/Contract-management/contracts",
            },
            { name: "Create" },
          ]}
        />
        <BackButton />
      </div>
      <div className="w-full mx-auto h-[calc(100vh-151px)] overflow-y-auto mt-4">
        <form onSubmit={formik.handleSubmit}>
          <div className="w-full h-full flex justify-start rounded-md bg-white content-start flex-wrap py-2 px-4 overflow-y-auto">
            <div className="w-full">
              <SettingHeading title="Contracts :" />
            </div>
            <NuInput
              type="text"
              label="Description"
              placeholder="Type here"
              formik={formik}
              name="description"
              width="w-full md:w-2/3 md:-mt-2"
            />
            <FormikSelectWithAdd
              label="Client "
              placeholder="Client  "
              Options={client}
              formik={formik}
              name="clientId"
              isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
              handleClick={togglePopup}
              setSearch={setSearchClient}
                FixPosition={true}
                      PortalTarget={false}
            />

            <FormikSelectTwo
              label="Survey Report"
              Options={Newcontract}
              formik={formik}
              placeholder="Choose"
              name="srId"
              width="w-full md:w-1/3"
                FixPosition={true}
                      PortalTarget={false}
            />

            <NuInput
              type="text"
              label="Building Name"
              placeholder="Type here"
              formik={formik}
              name="buildingName"
              width="w-full md:w-2/3 md:-mt-2"
            />

            <NuInput
              type="number"
              label="Amount"
              placeholder="Amount"
              formik={formik}
              name="amount"
              width="w-full md:w-1/3"
            />
            <FormikSelectTwo
              label="Contract Duration"
              placeholder="Choose"
              Options={[
                { value: "1 Month", label: "1 Month" },
                { value: "3 Months", label: "3 Months" },
                { value: "6 Months", label: "6 Months" },
                { value: "12 Months", label: "12 Months" },
                { value: "24 Months", label: "24 Months" },
                { value: "36 Months", label: "36 Months" },
              ]}
              formik={formik}
              name="duration"
              width="w-full md:w-1/3"
              isRequired={true}
                FixPosition={true}
                      PortalTarget={false}
            />
            <NuDate
              label="Contract Start Date"
              placeholder="Contract Start Date"
              formik={formik}
              name="startDate"
              width="w-full md:w-1/3"
              isRequired={true}
              min={new Date().toISOString().split("T")[0]}
            />

            <NuDate
              label="Contract End Date"
              formik={formik}
              name="endDate"
              width="w-full md:w-1/3 "
              isRequired={true}
              min={minRenewalDate || new Date().toISOString().split("T")[0]}
            />
            <NuDate
              label="Contract Renewal Date"
              formik={formik}
              name="renewalDate"
              width="w-full md:w-1/3 "
              isRequired={true}
              min={minRenewalDate || new Date().toISOString().split("T")[0]}
            />

            <NuInput
              type="number"
              label="Renewal Notice Period "
              placeholder="Renewal Notice Period"
              formik={formik}
              name="noticePeriod"
              width="w-full md:w-1/3 "
            />

             <DropDownAddMetaData
                            label="Payment Terms"
                            placeholder="Choose"
                            Options={paymentTerms}
                            formik={formik}
                            name="paymentTerms"
                            width="w-full md:w-1/2 lg:w-1/3 md:-mt-1"
                            getFunc={refpaymentTerms}
                            displayProperty={"Payment Terms"}
                            propertyName={"paymentTerms"}
                              FixPosition={true}
                      PortalTarget={false}
                          />
                        <NuTextArea
                          label="Notes"
                          placeholder="Notes"
                          formik={formik}
                          name="notes"
                          new_width="w-full md:w-2/3 "
            
                          width="w-full md:w-1/2 lg:w-1/3"
                        />

            <div className="w-full">
              <SettingHeading title="Attachments :" />
            </div>
            <Attachement
              handleChange={handleImageChange}
              preview={image || ""}
              width="w-full"
              label="Attach"
              multiple={true}
              removeImages={removeImages}
            />
          </div>

          <div className="w-full mx-auto bg-white rounded-md pb-4 mt-4">
            <div className="w-full h-full flex justify-start content-start flex-wrap mb-4">
              <div className="w-full px-4">
                <SettingHeading title="Inspection Schedule" />
              </div>
              <div className="w-full m-2 border border-solid rounded-lg">
                <div className="md:grid grid-cols-12 gap-1">
                  <div className="col-span-4 pt-2">
                    <SelectProductWithError
                      type="text"
                      label="Item / Activity"
                      placeholder="Item / Activity"
                      Options={sortedProList}
                      formik={formikAddInspection}
                      name="equipmentId"
                      width="w-full md:mt-[-7px]"
                      ErrMessage={inspectionProductError}
                      handleClick={togglePopupEqupiment}
                      setSearch={setSearchequipment}
                      FixPosition={true}
                      PortalTarget={false}
                    />
                  </div>
                  {/* <div className="col-span-3">
                    <DropDownAddUnitWithError
                      label="Unit"
                      placeholder="Choose"
                      Options={unit}
                      formik={formikAddInspection}
                      name="unit"
                      width="w-full"
                      getFunc={refunit}
                      displayProperty="Add Unit"
                      propertyName="unit_equipments"
                      ErrMessage={inspectionUnitError}
                      FixPosition={true}
                      PortalTarget={false}
                    />
                  </div>
                  <div className="col-span-3">
                    <NuInputWithError
                      label="Quantity"
                      type="number"
                      formik={formikAddInspection}
                      placeholder="Quantity"
                      name="quantity"
                      width="w-full"
                      ErrMessage={inspectionQuantityError}
                    />
                  </div> */}
                  <div className="col-span-2">
                    <DropDownAddMetaData
                      label="Location"
                      placeholder="Choose"
                      Options={location}
                      formik={formikAddInspection}
                      name="location"
                      width="w-full md:mt-[-3px]"
                      getFunc={reflocation}
                      displayProperty="Location"
                      propertyName="Inspection_Location"
                      FixPosition={true}
                      PortalTarget={false}
                    />
                  </div>

                  <div className="col-span-2">
                    <FormikSelectTwo
                      label="Schedule"
                      placeholder="Choose"
                      Options={[
                        { value: "Monthly", label: "Monthly" },
                        { value: "Quarterly", label: "Quarterly" },
                        { value: "Half-yearly", label: "Half-yearly" },
                        { value: "Yearly", label: "Yearly" },
                      ]}
                      formik={formikAddInspection}
                      name="inspectionType"
                      width="w-full"
                      FixPosition={true}
                      PortalTarget={false}
                    />
                  </div>
                  <div className="col-span-3">
                    <MultiSelect
                      label="Form Selection"
                      Options={form}
                      formik={formikAddInspection}
                      placeholder="Choose"
                      name="formSelection"
                      width="w-full"
                        FixPosition={true}
                      PortalTarget={false}
                    />
                  </div>
                  <div className=" flex justify-center md:items-end mb-4">
                    <button
                      onClick={handleAddInspection}
                      type="button"
                      className="px-6 h-8 bg-baseColor-primary text-white text-xs font-medium rounded-lg"
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
              <div className="w-full bg-white overflow-y-scroll mt-5">
                {inspectionError && (
                  <p className="text-xs font-semibold text-red-500 px-4">
                    {inspectionError}
                  </p>
                )}

                <div className=" w-full h-[calc(100vh-250px)] relative overflow-auto hidden md:block">
                  <div className="sticky top-0 w-full py-3 bg-baseColor-primary justify-between rounded-lg px-6 hidden md:flex text-white text-xs font-medium">
                    <div className=" w-[5%] text-left">S.No</div>
                    <div className=" w-[45%] text-left">Item / Activity</div>
                    <div className=" w-[22%] text-left">Location</div>
                    <div className=" w-[23%] text-left">Schedule</div>
                    {/* <div className=" w-[15%] text-center">Quantity</div> */}
                    <div className=" w-[5%] text-left flex items-center gap-3">
                      <p className="">Action</p>
                      <span
                        className=" cursor-pointer"
                        onClick={() => isInspectionEditable((prev) => !prev)}
                      >
                        <EditIcon
                          width="14"
                          height="14"
                          color={isInspectionEditable ? "#facc15" : "#ffff"}
                        />
                      </span>
                    </div>
                  </div>
                  {items.map((List, index) => (
                    <div
                      key={index}
                      className="w-full odd:bg-white even:bg-gray-50 px-6 hidden md:block"
                    >
                      <div className="w-full py-2 flex items-center justify-between text-xs">
                        <div className=" w-[5%] text-left py-2">
                          {index + 1}
                        </div>
                        <div className=" w-[45%] text-left py-2">
                          {List?.productName}
                        </div>
                        <div className=" w-[22%] text-left py-2">
                          {List?.location}
                        </div>
                        <div className=" w-[23%] text-left py-2">
                          {List?.inspectionType}
                        </div>
                        {/* <div className=" w-[15%] text-center">
                          <Select
                            value={
                              unit.find((item) => item?.value === List?.unit) ||
                              null
                            }
                            options={isInspectionEditable ? unit : []}
                            onChange={(value) =>
                              handleProductUnitChange(
                                value,
                                index,
                                "inspection"
                              )
                            }
                            isDisabled={!isInspectionEditable}
                            className="text-xs"
                          />
                        </div> */}
                        {/* <div className=" w-[15%] text-center flex justify-center ">
                          <input
                            type="number"
                            className="w-11/12 mx-auto py-2.5 text-xs outline-none text-center border border-gray-300 rounded"
                            value={List?.quantity}
                            disabled={!isInspectionEditable}
                            onChange={(e) =>
                              handleQuantityChange(e, index, "inspection")
                            }
                          />
                        </div> */}
                        <div className=" w-[5%] text-left flex items-center gap-3">
                          <button
                            onClick={() =>
                              handleDeleteItem(index, "inspection")
                            }
                            type="button"
                            className="text-red-500 cursor-pointer ml-4 border-none"
                          >
                            <DeleteIcon color="red" height={12} />
                          </button>
                        </div>
                      </div>
                      <div className="w-full py-2 flex text-xs">
                        <div className=" w-[5%] py-2"></div>
                        {/* <div className=" w-[45%] py-2">
                          <p className=" text-left text-xs font-medium text-[#111537]">
                            <span className="font-semibold">
                              Inspection Type :{" "}
                            </span>{" "}
                            {List?.inspectionType}
                          </p>
                        </div> */}
                        <div className=" w-[45%] py-1  ">
                          {/* <span className="font-semibold">Form : </span> */}
                          <div className="mt-2 flex  gap-2">
                            {List?.formSelection &&
                            List?.formSelection.length > 0 ? (
                              List.formSelection
                                .map(
                                  (val) =>
                                    form?.find((item) => item.value === val)
                                      ?.label
                                )
                                .filter(Boolean)
                                .map((label, idx) => (
                                  <div
                                    key={idx}
                                    className="flex items-start gap-2 p-1.5 bg-white border border-gray-200 rounded-md text-xs text-gray-700  transition"
                                  >
                                    <div className="flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-textColor-main font-semibold text-[10px]">
                                      {idx + 1}
                                    </div>
                                    <p className="flex-1">{label}</p>
                                  </div>
                                ))
                            ) : (
                              <div className="text-xs text-[#111537] mt-1">
                                -
                              </div>
                            )}
                          </div>
                        </div>
                        <div className=" w-[5%] py-2"></div>
                      </div>
                    </div>
                  ))}
                </div>


{/* mobile responsive  */}
                <div className="md:hidden space-y-4 mt-4 px-4">
                  {items.map((List, index) => (
                    <div
                      key={index}
                      className="p-3 border text-xs font-medium text-[#111537] rounded shadow-sm space-y-2 odd:bg-white even:bg-gray-100"
                    >
                      <div className="text-right">
                        <button
                          onClick={() => handleDeleteItem(index, "inspection")}
                          type="button"
                          className="text-red-500 text-xs"
                        >
                          <DeleteIcon color="red" height={12} />
                        </button>
                      </div>
                      <div>
                        <span className="text-xs font-medium text-[#111537]">
                          S.No :
                        </span>{" "}
                        {index + 1}
                      </div>
                      <div>
                        <span className="text-xs font-medium text-[#111537]">
                          Equipment :
                        </span>{" "}
                        {List?.productName}
                      </div>
                      <div>
                        <span className="text-xs font-medium text-[#111537]">
                          Location :
                        </span>{" "}
                        {List?.location}
                      </div>

                      
                      {/* <div className="flex justify-between items-center">
                        <span className="text-xs font-medium text-[#111537]">
                          Unit:
                        </span>
                        <span
                          className="cursor-pointer text-xs font-medium text-[#111537]"
                          onClick={() =>
                            setIsInspectionEditable((prev) => !prev)
                          }
                        >
                          <EditIcon
                            width="14"
                            height="14"
                            color={isInspectionEditable ? "#facc15" : "#9ca3af"}
                          />
                        </span>
                      </div> */}
                      {/* <Select
                        value={
                          unit.find((item) => item?.value === List?.unit) ||
                          null
                        }
                        options={isInspectionEditable ? unit : []}
                        onChange={(value) =>
                          handleProductUnitChange(value, index, "inspection")
                        }
                        isDisabled={!isInspectionEditable}
                      /> */}
                      {/* <div className="flex justify-between items-center pt-2">
                        <span className="text-xs font-medium text-[#111537]">
                          Quantity:
                        </span>
                        <span
                          className="cursor-pointer text-xs font-medium text-[#111537]"
                          onClick={() =>
                            setIsInspectionEditable((prev) => !prev)
                          }
                        >
                          <EditIcon
                            width="14"
                            height="14"
                            color={isInspectionEditable ? "#facc15" : "#9ca3af"}
                          />
                        </span>
                      </div> */}
                      {/* <input
                        type="number"
                        className="w-full border px-2 py-2.5 rounded text-xs"
                        value={List?.quantity}
                        disabled={!isInspectionEditable}
                        onChange={(e) =>
                          handleQuantityChange(e, index, "inspection")
                        }
                      /> */}
                      <div>
                        <span className="text-xs font-medium text-[#111537]">
                          Schedule :
                        </span>{" "}
                        {List?.inspectionType}
                      </div>
                      <div>
                        <span className="text-xs font-medium text-[#111537]">
                          Form Selection:
                        </span>{" "}
                        {List?.formSelection && List?.formSelection.length > 0 ? (
    List.formSelection
      .map((val) => form?.find((item) => item.value === val)?.label)
      .filter(Boolean)
      .map((label, idx) => (
        <div
          key={idx}
          className="flex items-start gap-2 p-1.5 bg-white border border-gray-200 rounded-md text-xs text-gray-700 transition"
        >
          <div className="flex items-center justify-center w-5 h-5 rounded-full bg-blue-100 text-textColor-main font-semibold text-[10px]">
            {idx + 1}
          </div>
          <p className="flex-1">{label}</p>
        </div>
      ))
  ) : (
    <div className="text-xs text-[#111537] mt-1">-</div>
  )}
                      </div>
                      
                    </div>
                  ))}
                </div>
              <div className="flex justify-end gap-4 mt-2 ">
               <CancelButton handleClick={() => Oncancel(-1)} />
               <SubmitButton isLoading={isLoading} />
            </div>
              </div>
            </div>
          </div>

          {/* <div className="w-full mx-auto bg-white rounded-md pb-4 mt-4">
            <div className="w-full h-full flex justify-start content-start flex-wrap mb-4">
              <div className="w-full flex justify-between p-2">
                <div className="w-full px-2">
                  <SettingHeading title="Equipment Detail" />
                </div>
                <div className="flex gap-4">
                  <ImportButton
                    label="Import"
                    handleClick={handleImportClick}
                  />
                  <ExportButton
                    label="Export"
                    handleClick={() => setShowExport(true)}
                  />
                </div>
              </div>
              <div className="w-full px-2 m-2 flex flex-col md:flex-row gap-y-3 md:gap-y-0 justify-start gap-3 border border-solid rounded-lg">
                <SelectProductWithError
                  type="text"
                  label="Equipment "
                  placeholder="Equipment "
                  Options={sortedProList}
                  formik={formikAddEquipment}
                  name="equipmentId"
                  width="w-full md:w-1/2 lg:w-[67%] z-10"
                  ErrMessage={equipmentProductError}
                  px="0"
                  handleClick={togglePopupEqupiment}
                  setSearch={setSearchequipment}
                  FixPosition={true}
                  PortalTarget={false}
                />
                <DropDownAddUnitWithError
                  label="Unit"
                  placeholder="Choose"
                  Options={unit}
                  formik={formikAddEquipment}
                  name="unit"
                  width="w-full md:w-1/2 lg:w-1/4"
                  getFunc={refunit}
                  displayProperty={"Add Unit"}
                  propertyName={"unit_equipments"}
                  ErrMessage={equipmentUnitError}
                  FixPosition={true}
                  PortalTarget={false}
                />
                <NuInputWithError
                  label="Quantity"
                  type="number"
                  formik={formikAddEquipment}
                  placeholder="Quantity"
                  name="quantity"
                  width="w-full md:w-1/2 lg:w-1/4"
                  ErrMessage={equipmentQuantityError}
                />
                <button
                  onClick={handleAddEquipment}
                  type="button"
                  className="p-1 mt-8 m-1 text-center h-8 cursor-pointer bg-baseColor-primary border border-solid border-white text-xs font-medium text-white rounded-lg"
                >
                  Add
                </button>
              </div>
              <div className="w-full bg-white overflow-y-scroll mt-5">
                {equipmentError && (
                  <p className="text-xs font-semibold text-red-500 px-4">
                    {equipmentError}
                  </p>
                )}
                <div className="w-full py-3 bg-baseColor-primary justify-between rounded-lg px-6 hidden md:flex">
                  <p className="w-[5%] text-left text-white text-xs font-medium">
                    S.No
                  </p>
                  <p className="w-[55%] text-left text-white text-xs font-medium">
                    Equipment
                  </p>
                  <p className="w-[15%] text-center pl-4 text-white text-xs font-medium flex justify-center">
                    Unit
                  </p>
                  <p className="w-[20%] text-center text-white text-xs font-medium flex justify-center">
                    Quantity
                  </p>
                  <p className="w-[5%] text-right text-white text-xs font-medium pr-1">
                    Action
                  </p>
                  <span
                    className="pl-1 cursor-pointer"
                    onClick={() => setIsEquipmentEditable((prev) => !prev)}
                  >
                    <EditIcon
                      width="14"
                      height="14"
                      color={isEquipmentEditable ? "#facc15" : "#ffff"}
                    />
                  </span>
                </div>
                <div className="h-[calc(100vh-300px)] overflow-y-scroll hidden md:block">
                  {Equipitems.map((List, index) => (
                    <div
                      key={index}
                      className="w-full py-2 flex justify-between px-6 odd:bg-white even:bg-slate-100"
                    >
                      <p className="w-[5%] text-left text-xs font-medium text-[#111537] py-2.5">
                        {index + 1}
                      </p>
                      <p className="w-[55%] text-left text-xs font-medium text-[#111537] py-2.5">
                        {List?.productName}
                      </p>
                      <p className="w-[15%] text-center pl-4 text-xs font-medium text-[#111537]">
                        <Select
                          value={
                            unit.find((item) => item?.value === List?.unit) ||
                            null
                          }
                          options={isEquipmentEditable ? unit : []}
                          onChange={(value) =>
                            handleProductUnitChange(value, index, "equipment")
                          }
                          isDisabled={!isEquipmentEditable}
                        />
                      </p>
                      <p className="w-[20%] text-center text-xs font-medium text-[#111537] ">
                        <input
                          type="number"
                          className="w-11/12 py-2.5 mx-auto outline-none text-center border border-gray-300 rounded"
                          value={List?.quantity}
                          disabled={!isEquipmentEditable}
                          onChange={(e) =>
                            handleQuantityChange(e, index, "equipment")
                          }
                        />
                      </p>
                      <div className="w-[5%] text-right py-2.5">
                        <button
                          onClick={() => handleDeleteItem(index, "equipment")}
                          type="button"
                          className="text-red-500 cursor-pointer ml-4 border-none"
                        >
                          <DeleteIcon color="red" height={12} />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="md:hidden space-y-4 mt-4 px-4">
                  {Equipitems.map((List, index) => (
                    <div
                      key={index}
                      className="p-3 border text-xs font-medium text-[#111537] rounded shadow-sm space-y-2 bg-gray-50"
                    >
                      <div>
                        <span className="text-xs font-medium text-[#111537]">
                          S.No:
                        </span>{" "}
                        {index + 1}
                      </div>
                      <div>
                        <span className="text-xs font-medium text-[#111537]">
                          Equipment:
                        </span>{" "}
                        {List?.productName}
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-xs font-medium text-[#111537]">
                          Unit:
                        </span>
                        <span
                          className="cursor-pointer text-xs font-medium text-[#111537]"
                          onClick={() =>
                            setIsEquipmentEditable((prev) => !prev)
                          }
                        >
                          <EditIcon
                            width="14"
                            height="14"
                            color={isEquipmentEditable ? "#facc15" : "#9ca3af"}
                          />
                        </span>
                      </div>
                      <Select
                        value={
                          unit.find((item) => item?.value === List?.unit) ||
                          null
                        }
                        options={isEquipmentEditable ? unit : []}
                        onChange={(value) =>
                          handleProductUnitChange(value, index, "equipment")
                        }
                        isDisabled={!isEquipmentEditable}
                      />
                      <div className="flex justify-between items-center pt-2">
                        <span className="text-xs font-medium text-[#111537]">
                          Quantity:
                        </span>
                        <span
                          className="cursor-pointer text-xs font-medium text-[#111537]"
                          onClick={() =>
                            setIsEquipmentEditable((prev) => !prev)
                          }
                        >
                          <EditIcon
                            width="14"
                            height="14"
                            color={isEquipmentEditable ? "#facc15" : "#9ca3af"}
                          />
                        </span>
                      </div>
                      <input
                        type="number"
                        className="w-full border px-2 py-1 rounded text-xs"
                        value={List?.quantity}
                        disabled={!isEquipmentEditable}
                        onChange={(e) =>
                          handleQuantityChange(e, index, "equipment")
                        }
                      />
                      <div className="text-right">
                        <button
                          onClick={() => handleDeleteItem(index, "equipment")}
                          type="button"
                          className="text-red-500 text-xs mt-2"
                        >
                          <DeleteIcon color="red" height={12} />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div> */}
        </form>
      </div>

      {showImportModal && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[85%] sm:min-w-[50%] 2xl:min-w-[40%] max-w-[50%] 2xl:max-w-[40%] max-h-[80vh] relative bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-gray-800">Import</h2>
              <button
                onClick={closeModal}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div className="mb-4">
              <NuUpload
                label="Equipment"
                width="w-full"
                accept=".xlsx, .xls"
                onChange={(e) => {
                  const file = e.target.files[0];
                  readExcel(file);
                }}
              />
            </div>
            <div className="flex justify-end gap-3">
              <button
                onClick={closeModal}
                className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm  text-textColor-main bg-[#E6F2F2] hover:bg-gray-300 rounded-md flex items-center"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  const fileInput =
                    document.querySelector('input[type="file"]');
                  if (fileInput.files[0]) {
                    readExcel(fileInput.files[0]);
                  } else {
                    setError("Please select a file to import.");
                  }
                }}
                className="px-4 py-2 bg-baseColor-primary text-white rounded-lg hover:bg-baseColor-primary"
              >
                Import
              </button>
            </div>
          </div>
        </div>
      )}

      {showPopup && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-lg font-normal text-[12px]">Add Client</h2>
            <form onSubmit={handlePopupSubmit}>
              <div className="mb-4 flex flex-wrap">
                <NuInput
                  type="text"
                  label="Company "
                  placeholder="Company "
                  formik={formik}
                  name="companyName"
                  width="w-full md:w-1/2 lg:w-1/2"
                  isRequired={true}
                />
                <NuInput
                  type="email"
                  label="Email"
                  placeholder="Email"
                  formik={formik}
                  name="email"
                  width="w-full md:w-1/2 lg:w-1/2"
                />
                <NuMobileNumber
                  nunCode="countryCode"
                  label="Phone"
                  placeholder="Phone"
                  formik={formik}
                  name="phone"
                  FixPosition={true}
                  PortalTarget={false}
                  width="w-full md:w-1/2 lg:w-1/2"
                />
                <DropDownAddMetaData
                  type="text"
                  label="Industry"
                  placeholder="Industry"
                  Options={industry}
                  formik={formik}
                  name="industry"
                  width="w-full md:w-1/2 lg:w-1/2"
                  displayProperty={"Industry"}
                  propertyName={"industry"}
                  getFunc={refindustry}
                  FixPosition={true}
                  PortalTarget={false}
                />
                <FormikSelectTwo
                  Options={Rating}
                  label="Ratings"
                  placeholder="Ratings"
                  formik={formik}
                  name="ratings"
                  width="w-full md:w-1/2 lg:w-1/2"
                />
                <div className="w-full">
                  <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                    Primary Contact :
                  </p>
                </div>
                <NuInput
                  type="text"
                  label="Contact Person "
                  placeholder="Contact Person "
                  formik={formik}
                  name="pcName"
                  width="w-full md:w-1/2 lg:w-1/2"
                />
                <DropDownAddMetaData
                  type="text"
                  label="Designation"
                  placeholder="Designation"
                  Options={designation}
                  formik={formik}
                  name="pcDesignation"
                  width="w-full md:w-1/2 lg:w-1/2 md:-mt-1"
                  displayProperty={"Designation"}
                  propertyName={"Designation_Client"}
                  getFunc={refdesignation}
                  FixPosition={true}
                  PortalTarget={false}
                />
                <NuMobileNumber
                  nunCode="pcCountryCode"
                  label="Phone"
                  placeholder="Phone"
                  formik={formik}
                  name="pcMobile"
                  width="w-full md:w-1/2 lg:w-1/2"
                  FixPosition={true}
                  PortalTarget={false}
                />
                <NuInput
                  type="email"
                  label="Email"
                  placeholder="Email"
                  formik={formik}
                  name="pcEmail"
                  width="w-full md:w-1/2 lg:w-1/2"
                />
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={togglePopup}
                  className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2] hover:bg-gray-300 rounded-md flex items-center mr-2 text-textColor-main"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-textColor-main px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      )}


      {showExport && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[85%] sm:min-w-[50%] 2xl:min-w-[40%] max-w-[50%] 2xl:max-w-[40%] max-h-[80vh] relative bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-gray-800">
                Export Data
              </h2>
              
              <button
                onClick={closeFilterDialogebox}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <form onSubmit={ExportFormik.handleSubmit}>
              <p className=" text-sm">Are you sure to export all data from the table? </p>
              <div className="flex justify-end gap-3 mt-4">
                <button
                  type="button"
                  onClick={closeFilterDialogebox}
                  className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-baseColor-primary text-white rounded-lg hover:bg-baseColor-primary"
                >
                  Export
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

            {showPopupEquipment && (
              <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
                <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
                  <h2 className="text-lg font-normal text-[12px]">Add Equipment</h2>
                  <form onSubmit={handlePopupSubmitEquipmt}>
                    <div className="mb-4 flex flex-wrap">
                      <NuInput
                        label="Name"
                        placeholder="Name"
                        formik={formik}
                        name="name"
                        width="w-full"
                        new_width="w-full"
                      />
                    </div>
                    <div className="flex justify-end">
                      <button
                        type="button"
                        onClick={togglePopupEqupiment}
                        className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                        rounded-md flex items-center mr-2 text-textColor-main"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="bg-textColor-main px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                      >
                        Add
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

    </div>
  );
}

export default CreateContracts;
